import { Flex } from '@mantine/core';
import { useState } from 'react';

import { translate } from '@/shared/i18n/translate';
import { LBButton } from '@/shared/ui-kit/components';

export const ManageWorkRequestView = ({
  accept,
  reject
}: {
  accept: () => Promise<void> | void;
  reject: () => Promise<void> | void;
}) => {
  const [isSending, setIsSending] = useState(false);

  const handleClick = async (fn: () => Promise<void> | void) => {
    try {
      setIsSending(true);
      await fn();
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Flex gap={8}>
      <LBButton
        fullWidth
        disabled={isSending}
        loading={isSending}
        onClick={() => handleClick(reject)}
      >
        {translate('commons.reject')}
      </LBButton>
      <LBButton
        fullWidth
        disabled={isSending}
        loading={isSending}
        onClick={() => handleClick(accept)}
      >
        {translate('commons.accept')}
      </LBButton>
    </Flex>
  );
};
